// This file was generated by a custom prisma generator, do not edit manually.

export const BusinessType = {
  UNKNOWN: "UNKNOWN",
  LTD: "LTD",
  PLC: "PLC",
  LLP: "LLP",
  CHARITY: "CHARITY",
  SOLE_TRADER: "SOLE_TRADER"
} as const;

export type BusinessType = (typeof BusinessType)[keyof typeof BusinessType];

export const PaymentMethod = {
  UNKNOWN: "UNKNOWN",
  NO_PAYMENT_DETAILS: "NO_PAYMENT_DETAILS",
  MONTHLY_DIRECT_DEBIT: "MONTHLY_DIRECT_DEBIT",
  QUARTERLY_DIRECT_DEBIT: "QUARTERLY_DIRECT_DEBIT",
  CASH_OR_CHEQUE: "CASH_OR_CHEQUE",
  EXISTING_WITH_SUPPLIER: "EXISTING_WITH_SUPPLIER",
  BACS: "BACS"
} as const;

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];

export const Salutation = {
  MR: "MR",
  MRS: "MRS",
  MS: "MS",
  DR: "DR",
  PROF: "PROF"
} as const;

export type Salutation = (typeof Salutation)[keyof typeof Salutation];

export const UtilityType = {
  ELECTRICITY: "ELECTRICITY",
  GAS: "GAS",
  WATER: "WATER",
  TELECOM: "TELECOM",
  INTERNET: "INTERNET",
  SOLAR: "SOLAR",
  BATTERY_STORAGE: "BATTERY_STORAGE",
  ENERGY_AUDIT: "ENERGY_AUDIT",
  FINANCE: "FINANCE",
  BUSINESS_INSURANCE: "BUSINESS_INSURANCE"
} as const;

export type UtilityType = (typeof UtilityType)[keyof typeof UtilityType];

export const QuoteStatus = {
  GENERATED: "GENERATED",
  SENDING: "SENDING",
  PROCESSED: "PROCESSED",
  DELIVERED: "DELIVERED",
  OPEN: "OPEN",
  CLICK: "CLICK",
  ACCEPTED: "ACCEPTED",
  PENDING: "PENDING",
  DROPPED: "DROPPED",
  DEFERRED: "DEFERRED",
  BOUNCE: "BOUNCE",
  BLOCKED: "BLOCKED",
  SPAMREPORT: "SPAMREPORT",
  UNSUBSCRIBE: "UNSUBSCRIBE",
  GROUP_UNSUBSCRIBE: "GROUP_UNSUBSCRIBE",
  GROUP_RESUBSCRIBE: "GROUP_RESUBSCRIBE",
  EXPIRED: "EXPIRED",
  ERROR: "ERROR",
  DELETED: "DELETED",
  CANCELLED: "CANCELLED"
} as const;

export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus];

export const QuoteType = {
  UD: "UD",
  CUSTOM: "CUSTOM",
  BESPOKE: "BESPOKE"
} as const;

export type QuoteType = (typeof QuoteType)[keyof typeof QuoteType];

export const UserRole = {
  DEVELOPER: "DEVELOPER",
  DIRECTOR: "DIRECTOR",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  SALES_AGENT: "SALES_AGENT",
  LEAD_GENERATOR: "LEAD_GENERATOR",
  COMPLIANCE: "COMPLIANCE",
  CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
  FINANCE: "FINANCE",
  SYSTEM: "SYSTEM",
  QUOTE_APP: "QUOTE_APP"
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const LeadGenPassoverState = {
  PASS_OVER: "PASS_OVER",
  REJECTED: "REJECTED"
} as const;

export type LeadGenPassoverState =
  (typeof LeadGenPassoverState)[keyof typeof LeadGenPassoverState];

export const ActivityType = {
  COMPANY: "COMPANY",
  SITE: "SITE",
  METER: "METER",
  DEAL: "DEAL",
  COMPLIANCE: "COMPLIANCE",
  ADMIN: "ADMIN",
  PAYMENT: "PAYMENT",
  POOL_AND_SEGMENT: "POOL_AND_SEGMENT",
  DOCUMENT: "DOCUMENT",
  NOTE: "NOTE",
  INTERACTION: "INTERACTION",
  CALLBACK: "CALLBACK",
  PROFILE: "PROFILE"
} as const;

export type ActivityType = (typeof ActivityType)[keyof typeof ActivityType];

export const SiteStatus = {
  ACTIVE: "ACTIVE",
  CEASED: "CEASED"
} as const;

export type SiteStatus = (typeof SiteStatus)[keyof typeof SiteStatus];

export const NoteProfileType = {
  COMPANY: "COMPANY",
  SITE: "SITE"
} as const;

export type NoteProfileType =
  (typeof NoteProfileType)[keyof typeof NoteProfileType];

export const ProviderStatus = {
  REVIEW_REQUIRED: "REVIEW_REQUIRED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE"
} as const;

export type ProviderStatus =
  (typeof ProviderStatus)[keyof typeof ProviderStatus];

export const EmailTransactionEvents = {
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  DROPPED: "DROPPED",
  DELIVERED: "DELIVERED",
  DEFERRED: "DEFERRED",
  BOUNCE: "BOUNCE",
  BLOCKED: "BLOCKED",
  OPEN: "OPEN",
  CLICK: "CLICK",
  SPAMREPORT: "SPAMREPORT",
  UNSUBSCRIBE: "UNSUBSCRIBE",
  GROUP_UNSUBSCRIBE: "GROUP_UNSUBSCRIBE",
  GROUP_RESUBSCRIBE: "GROUP_RESUBSCRIBE"
} as const;

export type EmailTransactionEvents =
  (typeof EmailTransactionEvents)[keyof typeof EmailTransactionEvents];

export const CompanyFileType = {
  WRITTEN_LOA: "WRITTEN_LOA",
  VERBAL_LOA: "VERBAL_LOA",
  WRITTEN_CONTRACT: "WRITTEN_CONTRACT",
  VERBAL_CONTRACT: "VERBAL_CONTRACT",
  FULL_CALL: "FULL_CALL",
  LOA: "LOA",
  CREDIT_CHECK: "CREDIT_CHECK",
  COMPANIES_HOUSE: "COMPANIES_HOUSE",
  TERMINATION: "TERMINATION",
  OTHER: "OTHER"
} as const;

export type CompanyFileType =
  (typeof CompanyFileType)[keyof typeof CompanyFileType];

export const LOAStatus = {
  DRAFT: "DRAFT",
  SENT: "SENT",
  SIGNED: "SIGNED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED"
} as const;

export type LOAStatus = (typeof LOAStatus)[keyof typeof LOAStatus];

export const DealStatus = {
  DEAL_MADE: "DEAL_MADE",
  SUBMITTED_TO_COMPLIANCE: "SUBMITTED_TO_COMPLIANCE",
  COMPLIANCE_ACCEPTED: "COMPLIANCE_ACCEPTED",
  COMPLIANCE_REJECTED: "COMPLIANCE_REJECTED",
  SUBMITTED_TO_SUPPLIER: "SUBMITTED_TO_SUPPLIER",
  OBJECTION_BY_OLD_SUPPLIER: "OBJECTION_BY_OLD_SUPPLIER",
  REJECTED_BY_NEW_SUPPLIER: "REJECTED_BY_NEW_SUPPLIER",
  CANCELLED: "CANCELLED",
  DEAD: "DEAD",
  AWAITING_LIVE: "AWAITING_LIVE",
  LIVE: "LIVE",
  FAILED_CREDIT: "FAILED_CREDIT",
  PREACTION: "PREACTION",
  PA_SETTLED: "PA_SETTLED"
} as const;

export type DealStatus = (typeof DealStatus)[keyof typeof DealStatus];

export const PaymentSource = {
  MANUAL: "MANUAL",
  STATEMENT_IMPORT: "STATEMENT_IMPORT"
} as const;

export type PaymentSource = (typeof PaymentSource)[keyof typeof PaymentSource];

export const ComplianceCheckStatus = {
  PENDING: "PENDING",
  PASSED: "PASSED",
  FAILED: "FAILED",
  NOT_REQUIRED: "NOT_REQUIRED"
} as const;

export type ComplianceCheckStatus =
  (typeof ComplianceCheckStatus)[keyof typeof ComplianceCheckStatus];

export const ComplianceReviewStatus = {
  PENDING: "PENDING",
  IN_REVIEW: "IN_REVIEW",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED"
} as const;

export type ComplianceReviewStatus =
  (typeof ComplianceReviewStatus)[keyof typeof ComplianceReviewStatus];

export const AdminReviewActivityStatus = {
  PENDING: "PENDING",
  IN_REVIEW: "IN_REVIEW",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED"
} as const;

export type AdminReviewActivityStatus =
  (typeof AdminReviewActivityStatus)[keyof typeof AdminReviewActivityStatus];

export const ComplianceReviewEntryStatus = {
  CREDIT_PENDING: "CREDIT_PENDING",
  CREDIT_PASSED: "CREDIT_PASSED",
  CREDIT_FAILED: "CREDIT_FAILED",
  CREDIT_NOT_REQUIRED: "CREDIT_NOT_REQUIRED",
  LOA_REQUIRED: "LOA_REQUIRED",
  LOA_PENDING: "LOA_PENDING",
  LOA_RETURNED: "LOA_RETURNED",
  LOA_NOT_REQUIRED: "LOA_NOT_REQUIRED",
  RECORDING_PENDING: "RECORDING_PENDING",
  RECORDING_ACCEPTED: "RECORDING_ACCEPTED",
  RECORDING_REJECTED: "RECORDING_REJECTED",
  RECORDING_NOT_APPLICABLE: "RECORDING_NOT_APPLICABLE",
  REVIEW_PENDING: "REVIEW_PENDING",
  REVIEW_IN_REVIEW: "REVIEW_IN_REVIEW",
  REVIEW_ACCEPTED: "REVIEW_ACCEPTED",
  REVIEW_REJECTED: "REVIEW_REJECTED",
  DEAL_LOCKED: "DEAL_LOCKED",
  DEAL_UNLOCKED: "DEAL_UNLOCKED"
} as const;

export type ComplianceReviewEntryStatus =
  (typeof ComplianceReviewEntryStatus)[keyof typeof ComplianceReviewEntryStatus];

export const AdminReviewEntryStatus = {
  SUPPLIER_DEAL_SUBMISSION_PENDING: "SUPPLIER_DEAL_SUBMISSION_PENDING",
  SUPPLIER_DEAL_SUBMISSION_SUBMITTED: "SUPPLIER_DEAL_SUBMISSION_SUBMITTED",
  SUPPLIER_DEAL_SUBMISSION_NOT_SUBMITTED: "SUPPLIER_DEAL_SUBMISSION_NOT_SUBMITTED",
  SUPPLIER_DEAL_SUBMISSION_NOT_APPLICABLE: "SUPPLIER_DEAL_SUBMISSION_NOT_APPLICABLE",
  SUPPLIER_LOA_SUBMISSION_PENDING: "SUPPLIER_LOA_SUBMISSION_PENDING",
  SUPPLIER_LOA_SUBMISSION_SUBMITTED: "SUPPLIER_LOA_SUBMISSION_SUBMITTED",
  SUPPLIER_LOA_SUBMISSION_NOT_SUBMITTED: "SUPPLIER_LOA_SUBMISSION_NOT_SUBMITTED",
  SUPPLIER_LOA_SUBMISSION_NOT_APPLICABLE: "SUPPLIER_LOA_SUBMISSION_NOT_APPLICABLE",
  SUPPLIER_TERMINATION_SUBMISSION_PENDING: "SUPPLIER_TERMINATION_SUBMISSION_PENDING",
  SUPPLIER_TERMINATION_SUBMISSION_SUBMITTED: "SUPPLIER_TERMINATION_SUBMISSION_SUBMITTED",
  SUPPLIER_TERMINATION_SUBMISSION_NOT_SUBMITTED: "SUPPLIER_TERMINATION_SUBMISSION_NOT_SUBMITTED",
  SUPPLIER_TERMINATION_SUBMISSION_NOT_APPLICABLE: "SUPPLIER_TERMINATION_SUBMISSION_NOT_APPLICABLE",
  SUPPLIER_DEAL_ACCEPTANCE_PENDING: "SUPPLIER_DEAL_ACCEPTANCE_PENDING",
  SUPPLIER_DEAL_ACCEPTANCE_ACCEPTED: "SUPPLIER_DEAL_ACCEPTANCE_ACCEPTED",
  SUPPLIER_DEAL_ACCEPTANCE_REJECTED: "SUPPLIER_DEAL_ACCEPTANCE_REJECTED",
  SUPPLIER_DEAL_ACCEPTANCE_NOT_APPLICABLE: "SUPPLIER_DEAL_ACCEPTANCE_NOT_APPLICABLE",
  SUPPLIER_LOA_ACCEPTANCE_PENDING: "SUPPLIER_LOA_ACCEPTANCE_PENDING",
  SUPPLIER_LOA_ACCEPTANCE_ACCEPTED: "SUPPLIER_LOA_ACCEPTANCE_ACCEPTED",
  SUPPLIER_LOA_ACCEPTANCE_REJECTED: "SUPPLIER_LOA_ACCEPTANCE_REJECTED",
  SUPPLIER_LOA_ACCEPTANCE_NOT_APPLICABLE: "SUPPLIER_LOA_ACCEPTANCE_NOT_APPLICABLE",
  SUPPLIER_TERMINATION_ACCEPTANCE_PENDING: "SUPPLIER_TERMINATION_ACCEPTANCE_PENDING",
  SUPPLIER_TERMINATION_ACCEPTANCE_ACCEPTED: "SUPPLIER_TERMINATION_ACCEPTANCE_ACCEPTED",
  SUPPLIER_TERMINATION_ACCEPTANCE_REJECTED: "SUPPLIER_TERMINATION_ACCEPTANCE_REJECTED",
  SUPPLIER_TERMINATION_ACCEPTANCE_NOT_APPLICABLE: "SUPPLIER_TERMINATION_ACCEPTANCE_NOT_APPLICABLE",
  ADMIN_LOA_PENDING: "ADMIN_LOA_PENDING",
  ADMIN_LOA_ACCEPTED: "ADMIN_LOA_ACCEPTED",
  ADMIN_LOA_REJECTED: "ADMIN_LOA_REJECTED",
  ADMIN_LOA_NOT_APPLICABLE: "ADMIN_LOA_NOT_APPLICABLE"
} as const;

export type AdminReviewEntryStatus =
  (typeof AdminReviewEntryStatus)[keyof typeof AdminReviewEntryStatus];

export const ContractType = {
  VERBAL: "VERBAL",
  WRITTEN: "WRITTEN"
} as const;

export type ContractType = (typeof ContractType)[keyof typeof ContractType];

export const ContractStatus = {
  GENERATED: "GENERATED",
  SENT: "SENT",
  SIGNED: "SIGNED",
  PROCESSING: "PROCESSING",
  CANCELLED: "CANCELLED"
} as const;

export type ContractStatus =
  (typeof ContractStatus)[keyof typeof ContractStatus];

export const CallbackStatus = {
  SCHEDULED: "SCHEDULED",
  CANCELLED: "CANCELLED",
  COMPLETE: "COMPLETE"
} as const;

export type CallbackStatus =
  (typeof CallbackStatus)[keyof typeof CallbackStatus];

export const QuoteRagState = {
  LANDING: "LANDING",
  SITE_INFO: "SITE_INFO",
  USAGE_INFO: "USAGE_INFO",
  SELECTING_QUOTE: "SELECTING_QUOTE",
  SIGNING_CONTRACT: "SIGNING_CONTRACT",
  CONTRACT_COMPLETE: "CONTRACT_COMPLETE",
  UNDEFINED: "UNDEFINED"
} as const;

export type QuoteRagState = (typeof QuoteRagState)[keyof typeof QuoteRagState];

export const CallbackDeleteReason = {
  URGENT_CUSTOMER_REQUEST: "URGENT_CUSTOMER_REQUEST",
  RESOURCE_MANAGEMENT: "RESOURCE_MANAGEMENT",
  CUSTOMER_PREFERENCE: "CUSTOMER_PREFERENCE",
  OTHER: "OTHER"
} as const;

export type CallbackDeleteReason =
  (typeof CallbackDeleteReason)[keyof typeof CallbackDeleteReason];

export const NotificationType = {
  TODAY_CALLBACK_NOTIFICATION: "TODAY_CALLBACK_NOTIFICATION",
  UPCOMING_CALLBACK_NOTIFICATION: "UPCOMING_CALLBACK_NOTIFICATION",
  VERIFY_CALLBACK_NOTIFICATION: "VERIFY_CALLBACK_NOTIFICATION",
  OVERDUE_CALLBACK_NOTIFICATION: "OVERDUE_CALLBACK_NOTIFICATION",
  ANNOUNCEMENT_NOTIFICATION: "ANNOUNCEMENT_NOTIFICATION",
  CURRENT_SUPPLIER_INFORMATION_EMAIL: "CURRENT_SUPPLIER_INFORMATION_EMAIL",
  QUOTE_SIGNUP_EMAIL: "QUOTE_SIGNUP_EMAIL",
  SIGN_CONTRACT_EMAIL: "SIGN_CONTRACT_EMAIL",
  DEAL_ACTIVITY_NOTIFICATION: "DEAL_ACTIVITY_NOTIFICATION"
} as const;

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];

export const PhoneNumberType = {
  MOBILE: "MOBILE",
  LANDLINE: "LANDLINE"
} as const;

export type PhoneNumberType =
  (typeof PhoneNumberType)[keyof typeof PhoneNumberType];

export const SaleType = {
  ACQUISITION: "ACQUISITION",
  RENEWAL: "RENEWAL"
} as const;

export type SaleType = (typeof SaleType)[keyof typeof SaleType];

export const QuoteSessionType = {
  QUOTE: "QUOTE",
  MARKETING: "MARKETING"
} as const;

export type QuoteSessionType =
  (typeof QuoteSessionType)[keyof typeof QuoteSessionType];

export const QuoteAcquisitionSource = {
  CAMPAIGN: "CAMPAIGN",
  ORGANIC: "ORGANIC"
} as const;

export type QuoteAcquisitionSource =
  (typeof QuoteAcquisitionSource)[keyof typeof QuoteAcquisitionSource];

export const PoolType = {
  STANDARD: "STANDARD",
  PRIVATE: "PRIVATE"
} as const;

export type PoolType = (typeof PoolType)[keyof typeof PoolType];

export const QuoteHistoryStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  COMPLETED: "COMPLETED"
} as const;

export type QuoteHistoryStatus =
  (typeof QuoteHistoryStatus)[keyof typeof QuoteHistoryStatus];

export const QuoteStep = {
  COMPANY_INFORMATION: "COMPANY_INFORMATION",
  SITE_INFORMATION: "SITE_INFORMATION",
  UTILITY_USAGE: "UTILITY_USAGE",
  UTILITY_QUOTES: "UTILITY_QUOTES",
  SIGN_CONTRACT: "SIGN_CONTRACT"
} as const;

export type QuoteStep = (typeof QuoteStep)[keyof typeof QuoteStep];
